module.exports = require(`./l10n.${LANGUAGE}.js`); // eslint-disable-line import/no-dynamic-require
